const FilterButton = ({
  label = "Filter",
  icon = "/icons/filter.png", // Default filter icon
  showIcon = true, // Optional prop to hide icon
  onClick,
  className = "",
  buttonClassName = "", // Inner button class
}) => {
  return (
    <div className={`cursor-pointer pr-1 ${className}`} onClick={onClick}>
      <div
        className={`w-auto min-w-[80px] h-6 rounded-[7px] px-2 flex items-center justify-center gap-2 
          ${buttonClassName || "bg-[#E5E6E7] text-black"}`}
      >
        {showIcon && (
          <img src={icon} alt={label} className="w-[16px] h-[16px]" />
        )}
        <span className="font-inter text-[11px] leading-[100%] tracking-[0%] whitespace-nowrap">
          {label}
        </span>
      </div>
    </div>
  );
};

export default FilterButton;
